// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPayrollGroupReducedDto } from './IPayrollGroupReducedDto';
import {
    IPayrollGroupReducedDtoFromJSON,
    IPayrollGroupReducedDtoFromJSONTyped,
    IPayrollGroupReducedDtoToJSON,
    IPayrollGroupReducedDtoToJSONTyped,
} from './IPayrollGroupReducedDto';

/**
 * 
 * @export
 * @interface IPayrollCalendarExtendedDto
 */
export interface IPayrollCalendarExtendedDto {
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarExtendedDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedDto
     */
    frequency_type?: IPayrollCalendarExtendedDtoFrequencyTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarExtendedDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarExtendedDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarExtendedDto
     */
    end_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedDto
     */
    status?: IPayrollCalendarExtendedDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarExtendedDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Date}
     * @memberof IPayrollCalendarExtendedDto
     */
    next_autoprolong_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedDto
     */
    json_config?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarExtendedDto
     */
    group_type?: IPayrollCalendarExtendedDtoGroupTypeEnum;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarExtendedDto
     */
    plan_ids?: Set<number>;
    /**
     * 
     * @type {Set<IPayrollGroupReducedDto>}
     * @memberof IPayrollCalendarExtendedDto
     */
    groups?: Set<IPayrollGroupReducedDto>;
    /**
     * 
     * @type {Array<Date>}
     * @memberof IPayrollCalendarExtendedDto
     */
    schedule?: Array<Date>;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarExtendedDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarExtendedDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarExtendedDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarExtendedDto interface.
 */
export function instanceOfIPayrollCalendarExtendedDto(value: object): value is IPayrollCalendarExtendedDto {
    return true;
}

export function IPayrollCalendarExtendedDtoFromJSON(json: any): IPayrollCalendarExtendedDto {
    return IPayrollCalendarExtendedDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'status': json['status'] == null ? undefined : json['status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'next_autoprolong_at': json['next_autoprolong_at'] == null ? undefined : (new Date(json['next_autoprolong_at'])),
        'json_config': json['json_config'] == null ? undefined : json['json_config'],
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
        'plan_ids': json['plan_ids'] == null ? undefined : new Set(json['plan_ids']),
        'groups': json['groups'] == null ? undefined : (new Set((json['groups'] as Array<any>).map(IPayrollGroupReducedDtoFromJSON))),
        'schedule': json['schedule'] == null ? undefined : json['schedule'],
    };
}

export function IPayrollCalendarExtendedDtoToJSON(json: any): IPayrollCalendarExtendedDto {
    return IPayrollCalendarExtendedDtoToJSONTyped(json, false);
}

export function IPayrollCalendarExtendedDtoToJSONTyped(value?: IPayrollCalendarExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'frequency_type': value['frequency_type'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString()),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString()),
        'status': value['status'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'next_autoprolong_at': value['next_autoprolong_at'] == null ? undefined : ((value['next_autoprolong_at']).toISOString()),
        'json_config': value['json_config'],
        'group_type': value['group_type'],
        'plan_ids': value['plan_ids'] == null ? undefined : Array.from(value['plan_ids'] as Set<any>),
        'groups': value['groups'] == null ? undefined : (Array.from(value['groups'] as Set<any>).map(IPayrollGroupReducedDtoToJSON)),
        'schedule': value['schedule'],
    };
}

